/**
 * @todo: Possibly move functionality close to presentation level,
 * @todo to `useStore`'s structure / store's $storeState $storeCommit responsibility holder/provider
 */
import { ValueObject, createValueObject } from './ValueObject';

export const filterObject = (object, filterFn) => Object.fromEntries(Object.entries(object).filter(filterFn));

/**
 * Builds store value (ValueObject) to keep in state
 * Encapsulates store value type and structure.
 *
 * @param {any} value
 * @param {?import('.').ValueObjectMeta} [meta=null]
 * @return {ValueObject}
 */
export const buildStoreValue = (value, meta = null) =>
    value instanceof ValueObject ? value : createValueObject(value, meta);

/**
 * Unwraps value from Store Value (ValueObject)
 *
 * @param {ValueObject} valueObject
 * @return {*}
 */
export const unwrapStoreValue = (valueObject) => ValueObject.getValue(valueObject);
